"use client";
import ProductCard from "@/app/views/popular/components/ProductCard";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import CustomBreadcrumbs from "@/custom/CustomBreadcrumbs";
import CustomPagination from "@/custom/CustomPagination";
import { LibraryBig } from "lucide-react";
import { useSearchParams } from "next/navigation";
import Filters from "./Filters";

const Products = ({
  products,
  total,
  count,
  authors,
  categories,
  publishers,
}) => {
  const searchParams = useSearchParams();
  const search = searchParams.get("search");

  return (
    <div className="container mx-auto space-y-10 my-10 px-4">
      <CustomBreadcrumbs text={search} />
      <div className="flex flex-col lg:flex-row items-start gap-4">
        <Filters
          authors={authors}
          categories={categories}
          publishers={publishers}
        />
        <div className="flex flex-wrap gap-4">
          {products?.length === 0 ? (
            <Card className="border-brand-light shadow-brand-sm rounded-2xl">
              <CardHeader>
                <CardTitle className="text-xl font-medium text-brand-navy">
                  <LibraryBig strokeWidth={1} size={45} className="text-brand-sky" />
                  <p>No Products Found</p>
                </CardTitle>
                <CardDescription className="text-muted-foreground">
                  We couldn&apos;t find any products matching your criteria.
                  Please adjust your search or reset filters. For assistance,
                  contact our support. Thank you.
                </CardDescription>
              </CardHeader>
            </Card>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
              {products?.map((book, i) => (
                <div className="w-full relative overflow-hidden border" key={i}>
                  <ProductCard product={book} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <CustomPagination total={total} count={count} />
    </div>
  );
};

export default Products;